import { Role } from 'features/auth/types';
import ClinicInfoEdit from 'features/clinic/clinic-info-edit/clinic-info-edit';
import ClinicUserManagement from 'features/clinician/clinic-user-management';
import ClinicianHomeV2 from 'features/clinician/patient/patient-list/patient-list';
import { ClinicianQueryPage } from 'features/clinician/clinician-query';
import { PrivateRouteProps } from 'navigation/router/components/routes/private-route';
import { Redirect } from 'react-router-dom';
import { Routes, ClinicRoutes, ClinicianRoutePrefix } from 'routes';
import { BillingContainer } from 'features/clinic/billing/BillingContainer';

export const CLINICIAN_ROUTES: PrivateRouteProps[] = [
  {
    path: Routes.ClinicianHome,
    roles: [Role.Clinician, Role.ClinicAdmin],
    component: ClinicianHomeV2
  },
  {
    path: ClinicRoutes.ClinicUserManagement,
    component: ClinicUserManagement,
    roles: [Role.ClinicAdmin]
  },
  {
    path: ClinicRoutes.ClinicInfoEdit,
    component: ClinicInfoEdit,
    roles: [Role.ClinicAdmin]
  },
  {
    path: ClinicRoutes.CrxCompanion,
    component: ClinicianQueryPage,
    roles: [Role.ClinicAdmin, Role.Clinician]
  },
  {
    path: '/clinician/billing/*', // New parent route for all billing features
    roles: [Role.Clinician, Role.ClinicAdmin],
    component: BillingContainer,
  },
  /**
   * # Fallback route
   * If nothing matched, then redirect to the ClinicianRoutePrefix and try again
   *
   * This is required so that the router does not create an infinite loop
   */
  {
    path: ClinicianRoutePrefix,
    roles: [Role.Clinician, Role.ClinicAdmin],
    component: () => <Redirect to={ClinicianRoutePrefix} />,
    redirectPath: ClinicianRoutePrefix
  }
];
